module.exports = __webpack_public_path__ + "img/yt.34c61b8c.svg";